import React, { useEffect, useState, Component } from 'react';
import { MenuIcon, XIcon, SearchIcon, UserIcon, PhoneIcon } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
export function NavBar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();
  const navigate = useNavigate();
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = searchQuery.trim();
    if (q) {
      navigate(`/locations?q=${encodeURIComponent(q)}`);
    } else {
      navigate('/locations');
    }
    setSearchQuery('');
  };
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    label: 'Services',
    to: '/services'
  }, {
    label: 'Locations',
    to: '/locations'
  }, {
    label: 'About',
    to: '/about'
  }, {
    label: 'Contact',
    to: '/contact'
  }];
  return <nav className="sticky top-0 z-50 shadow-md" role="navigation" aria-label="Main navigation" data-id="element-309">
      {/* ROW 1 — Main nav bar */}
      <div className="bg-white border-b border-gray-200" data-id="element-310">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-311">
          <div className="flex items-center justify-between h-16 gap-6" data-id="element-312">
            {/* Logo */}
            <Link to="/" className="flex-shrink-0" aria-label="Ameritech Tires home" data-id="element-313">
              <img src="https://cdn.magicpatterns.com/uploads/7USU4UNCfkQ3xhTRzMh17Q/ChatGPT_Image_Feb_27,_2026,_05_46_21_PM.png" alt="Ameritech Inc Tires & Wheels Center" className="h-12 w-auto object-contain" data-id="element-314" />
            </Link>

            {/* Center: Location Search (desktop) */}
            <div className="hidden lg:flex items-center flex-1 max-w-sm" data-id="element-315">
              <form onSubmit={handleSearch} className="flex w-full" data-id="element-316">
                <div className="relative flex-1" data-id="element-317">
                  <SearchIcon size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-318" />
                  <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Find an Ameritech Location" className="w-full pl-9 pr-3 py-2 bg-white border border-gray-300 text-black placeholder-gray-400 text-sm focus:outline-none focus:border-[#CC0000] rounded-l" aria-label="Find a location" data-id="element-319" />
                </div>
                <button type="submit" className="text-white px-4 py-2 font-bold text-sm rounded-r transition-colors flex-shrink-0" style={{
                background: '#a30000'
              }} onMouseEnter={e => e.currentTarget.style.background = '#8a0000'} onMouseLeave={e => e.currentTarget.style.background = '#a30000'} aria-label="Search locations" data-id="element-320">
                  Search
                </button>
              </form>
            </div>

            {/* Desktop Nav Links */}
            <div className="hidden md:flex items-center gap-7" data-id="element-321">
              {navLinks.map(link => {
              const isActive = location.pathname === link.to;
              return <Link key={link.label} to={link.to} className="text-gray-800 font-semibold text-sm transition-colors duration-150 whitespace-nowrap" style={{
                borderBottom: isActive ? '2px solid #CC0000' : '2px solid transparent',
                paddingBottom: '2px',
                color: isActive ? '#CC0000' : '#1a1a1a'
              }} onMouseEnter={e => e.currentTarget.style.color = '#CC0000'} onMouseLeave={e => e.currentTarget.style.color = isActive ? '#CC0000' : '#1a1a1a'} data-id="element-322">
                    {link.label}
                  </Link>;
            })}
            </div>

            {/* Mobile hamburger */}
            <button className="md:hidden p-2 text-gray-800" onClick={() => setMobileOpen(!mobileOpen)} aria-label={mobileOpen ? 'Close menu' : 'Open menu'} aria-expanded={mobileOpen} data-id="element-323">
              {mobileOpen ? <XIcon size={24} data-id="element-324" /> : <MenuIcon size={24} data-id="element-325" />}
            </button>
          </div>
        </div>
      </div>

      {/* ROW 2 — Secondary bar */}
      <div className="hidden md:block" style={{
      background: '#a30000'
    }} data-id="element-326">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-327">
          <div className="flex items-center justify-between h-9" data-id="element-328">
            <span className="text-white/90 text-xs" data-id="element-329">
              Walk-ins Welcome — No Appointment Needed
            </span>
            <div className="flex items-center gap-5" data-id="element-330">
              <a href="tel:3012549001" className="flex items-center gap-1.5 text-white text-xs font-bold hover:text-red-200 transition-colors" data-id="element-331">
                <PhoneIcon size={12} data-id="element-332" />
                Call (301) 254-9001
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && <div className="md:hidden bg-white border-t border-gray-200 px-4 py-4 space-y-1" data-id="element-333">
          {/* Mobile search */}
          <div className="flex mb-4" data-id="element-334">
            <form onSubmit={handleSearch} className="flex w-full" data-id="element-335">
              <div className="relative flex-1" data-id="element-336">
                <SearchIcon size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" data-id="element-337" />
                <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Find a location..." className="w-full pl-8 pr-3 py-2.5 bg-white border border-gray-300 text-black placeholder-gray-400 text-sm focus:outline-none rounded-l" data-id="element-338" />
              </div>
              <button type="submit" className="bg-gray-300 text-gray-800 px-3 py-2.5 font-bold text-sm rounded-r" data-id="element-339">
                Go
              </button>
            </form>
          </div>

          {navLinks.map(link => {
        const isActive = location.pathname === link.to;
        return <Link key={link.label} to={link.to} className="block font-semibold text-base py-2.5 px-2 rounded transition-colors" style={{
          color: isActive ? '#CC0000' : '#1a1a1a',
          background: isActive ? 'rgba(204,0,0,0.06)' : 'transparent'
        }} data-id="element-340">
                {link.label}
              </Link>;
      })}
          <a href="tel:3012549001" className="flex items-center gap-2 text-gray-800 font-bold text-sm py-3 px-2 mt-2 border-t border-gray-200" data-id="element-341">
            <PhoneIcon size={16} data-id="element-342" />
            Call (301) 254-9001
          </a>
        </div>}
    </nav>;
}